var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_704_530)" } }, [
        _c("path", {
          attrs: {
            d: "M11.375 0C12.3402 0 13.125 0.784766 13.125 1.75V12.25C13.125 13.2152 12.3402 14 11.375 14H3.5C2.53477 14 1.75 13.2152 1.75 12.25V1.75C1.75 0.784766 2.53477 0 3.5 0H11.375ZM8.3125 7.875H6.5625C5.35391 7.875 4.375 8.85391 4.375 10.0625C4.375 10.3031 4.57187 10.5 4.8125 10.5H10.0625C10.3031 10.5 10.5 10.3031 10.5 10.0625C10.5 8.85391 9.52109 7.875 8.3125 7.875ZM9.1875 5.25C9.1875 4.78587 9.00313 4.34075 8.67494 4.01256C8.34675 3.68437 7.90163 3.5 7.4375 3.5C6.97337 3.5 6.52825 3.68437 6.20006 4.01256C5.87187 4.34075 5.6875 4.78587 5.6875 5.25C5.6875 5.71413 5.87187 6.15925 6.20006 6.48744C6.52825 6.81563 6.97337 7 7.4375 7C7.90163 7 8.34675 6.81563 8.67494 6.48744C9.00313 6.15925 9.1875 5.71413 9.1875 5.25ZM0 2.1875C0 1.94687 0.196875 1.75 0.4375 1.75C0.678125 1.75 0.875 1.94687 0.875 2.1875V3.9375C0.875 4.17812 0.678125 4.375 0.4375 4.375C0.196875 4.375 0 4.17812 0 3.9375V2.1875ZM0.4375 5.25C0.678125 5.25 0.875 5.44688 0.875 5.6875V7.4375C0.875 7.67812 0.678125 7.875 0.4375 7.875C0.196875 7.875 0 7.67812 0 7.4375V5.6875C0 5.44688 0.196875 5.25 0.4375 5.25ZM0 9.1875C0 8.94687 0.196875 8.75 0.4375 8.75C0.678125 8.75 0.875 8.94687 0.875 9.1875V10.9375C0.875 11.1781 0.678125 11.375 0.4375 11.375C0.196875 11.375 0 11.1781 0 10.9375V9.1875Z",
            fill: "black",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_704_530" } }, [
          _c("rect", {
            attrs: {
              width: "14",
              height: "14",
              fill: "white",
              transform: "matrix(-1 0 0 1 14 0)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }